/**
 * Line colour of your car, or of the chosen car
 * @type {string}
 */
export const HIGHLIGHT_COLOUR = '#ff0000'

/**
 * Line colours of the other cars: the Google Charts palette without its reds and oranges,
 * so no car can be mistaken for yours
 * @type {Array<string>}
 */
export const LINE_COLOURS = [
  '#3366cc',
  '#109618',
  '#990099',
  '#0099c6',
  '#66aa00',
  '#316395',
  '#994499',
  '#22aa99',
  '#aaaa11',
  '#6633cc',
  '#329262',
  '#5574a6',
  '#3b3eac',
  '#651067',
  '#17becf',
  '#7f7f7f'
]

/**
 * Get the line colour of each car, the same in every chart of the same laps: the highlighted cars
 * in red, the others from the palette in the order of their first lap, so a car keeps its colour
 * when other cars join later
 * @param {Array<Object>} rows laps
 * @param {Array<number|string>} highlight cars to draw in red, such as yours and the chosen one
 * @returns {Object<string, string>} colour per car number; its keys list the car numbers in numeric order
 */
export const getCarColours = ( rows = [], highlight = [] ) =>
{
  const highlighted = highlight.filter( h => h !== '' && h !== null && h !== undefined ).map( h => String( h ) )
  const cars = [ ...new Set( [ ...rows ].sort( ( a, b ) => a.time > b.time ? 1 : -1 ).map( row => String( row.car ) ) ) ]
  const colours = {}
  let index = 0

  cars.forEach( car =>
  {
    colours[ car ] = highlighted.includes( car ) ? HIGHLIGHT_COLOUR : LINE_COLOURS[ index++ % LINE_COLOURS.length ]
  } )

  return colours
}

/**
 * Check whether a car is drawn as the highlighted one
 * @param {Object<string, string>} colours colour per car number, from getCarColours
 * @param {number|string} car car number
 * @returns {boolean} whether the car is drawn in red
 */
export const isHighlighted = ( colours, car ) => colours[ String( car ) ] === HIGHLIGHT_COLOUR
